<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <ValidationProvider name="catDocumentos_id" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'El tipo de documento es obligatorio',
        }">
          <label for="">Tipo de documento</label>
          <select class="custom-select" v-model="currentDocumento.catDocumentos_id">
            <option v-for="option in options_principal_documento" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
        <br>
      </div>
    </div>

    <div class="row mt-4" v-if="currentDocumento.catDocumentos_id == id_otro">
      <div class="col-md-12">
        <ValidationProvider name="descripcion" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'La descripción del documento es obligatoria',
        }">
          <base-input type="text" label="Descripción" placeholder="Descripción" v-model="currentDocumento.descripcion">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>


    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider name="descripcion" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'La cantidad de copias es obligatoria',
        }">
          <label for="">Número de copias certificadas</label>
          <base-input class="custom-number" type="number" required placeholder="1" min="1"
            v-model="currentDocumento.copias_certificadas">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider name="descripcion" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'La cantidad de páginas es obligatoria',
        }">
          <label for="">Número de páginas del documento sin anexos</label>
          <base-input class="custom-number" type="number" required placeholder="1" min="1"
            v-model="currentDocumento.paginas">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ValidationProvider name="anexo" v-slot="{ errors }">
          <b-form-checkbox v-model="currentDocumento.tiene_anexo">
            <span>El documento contiene anexo(s)</span>
          </b-form-checkbox>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="row mt-4" v-if="currentDocumento.tiene_anexo">
      <div class="col-md-12">
        <ValidationProvider name="descripcion" rules="required" v-slot="{ errors }" :custom-messages="{
          required: 'La cantidad de páginas es obligatoria',
        }">
          <label for="">Número total de páginas de todos los anexos</label>
          <base-input class="custom-number" type="number" required placeholder="1" :min="1"
            v-model="currentDocumento.paginas_anexo">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="mt-4 text-center">
      <button type="submit" class="btn btn-fill float-right orange-btn">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    optionsDocumentos: { type: Array },
    currentDocumento: { type: Object },
  },

  created() {
    this.getIdOtro();
    this.deleteAnexoFromDocuments();
  },

  data() {
    return {
      id_otro: null,
      is_anexo: false,
      options_principal_documento: [],
    };
  },

  methods: {
    getIdOtro() {
      this.optionsDocumentos.forEach(element => {
        if (element.text === 'Otro') {
          this.id_otro = element.value;
        }
      })
    },

    deleteAnexoFromDocuments() {
      if (this.currentDocumento.anexoDe) {
        this.options_principal_documento = this.optionsDocumentos;
        this.is_anexo = true;
      } else {
        this.optionsDocumentos.forEach(element => {
          const excludeDocumentos = ['Anexo', 'FAD', 'Carta Responsiva', 'Acta PDF', 'Acuse']
          if (!excludeDocumentos.includes(element.text)) {
            this.options_principal_documento.push(element);
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.custom-number {
  width: 100px !important;
  display: inline-block;
  margin-left: 30px;
}
</style>
